import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import UploadScanning from 'components/UploadScanning';
import UploadError from 'components/UploadError';
export var errorText = {
    infected: 'Upload Failed', // I want to play a game
    invalid_link: 'Invalid link',
    sanitization_failed: 'Malformed file - have user confirm file is not corrupt'
};
var getScanStatus = function (scan_status, component) {
    switch (scan_status) {
        case 'started':
            return (_jsxs(_Fragment, { children: [component, _jsx(UploadScanning, {})] }));
        case 'infected':
        case 'sanitization_failed':
        case 'invalid_link':
            return _jsx(UploadError, { text: errorText[scan_status] });
        case 'not_checked':
        case 'sanitized':
        case 'clean':
        default:
            return component;
    }
};
export default getScanStatus;
